import { endOfMonth, format, startOfMonth, subMonths } from 'date-fns';

import type { CollectedRevenueMonthlyTrendItem } from '~entities/dashboard/api/get-collected-revenue-monthly-trend';

export function getCollectedRevenueMonthlyTrendStartDate(): string {
  return format(startOfMonth(subMonths(new Date(), 4)), 'yyyy-MM-dd');
}

export function getCollectedRevenueMonthlyTrendEndDate(): string {
  return format(endOfMonth(new Date()), 'yyyy-MM-dd');
}

const UTC_MONTH_LABELS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
] as const;

/** Matches monthly-trend month labels (UTC) from the API, e.g. "Jun 2025". */
export function getCurrentUtcMonthLabel(): string {
  const now = new Date();
  return `${UTC_MONTH_LABELS[now.getUTCMonth()]} ${now.getUTCFullYear()}`;
}

export function getCurrentMonthTrend(
  data: CollectedRevenueMonthlyTrendItem[] | undefined,
): CollectedRevenueMonthlyTrendItem | undefined {
  if (data == null || data.length === 0) {
    return undefined;
  }

  const currentMonthLabel = getCurrentUtcMonthLabel();
  return (
    data.find((item) => item.month === currentMonthLabel) ??
    data[data.length - 1]
  );
}
